// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rA4e","newExpiryDate":"styles_newExpiryDate__2asFK","footer":"styles_footer__zXjl6"};